module.exports = __webpack_public_path__ + "img/41-CAMICIA-PINOT-SML-COLORI-LINO--PANTALONE-RIESLING-SML-COLORI-LINO-STAMPE-LINO4.85db82a4.jpg";